import { cpf, cnpj } from 'cpf-cnpj-validator'
import Vue from 'vue'

const formatCpfCnpj = (value = '') => {
  const cpfCnpjCleared = value.replace(/\D/g, '')
  if (cpfCnpjCleared.length === 11) return cpf.format(cpfCnpjCleared)
  if (cpfCnpjCleared.length === 14) return cnpj.format(cpfCnpjCleared)
  return value
}

Vue.filter('cpfCnpj', formatCpfCnpj)

export default Vue

export {
  formatCpfCnpj
}